// The light 1 s tick feed (backend TickFeedService → SSE event "ticks"): the index spot and the live
// LTP of each strike held in an open trade — the mark (bid/ask mid when sane, else the last trade), the
// same price as the 5 s chain's ceLTP/peLTP. Kept outside React state on purpose: a tick re-renders only
// the components that read it (useLiveTicks), not the whole AnalyzerPage every second.
import { useSyncExternalStore } from 'react';

const MAX_AGE_MS = 5000; // older than this → callers fall back to the 5 s chain prices

let current = null;
const listeners = new Set();

export const setLiveTicks = (ticks) => {
  current = ticks ? { ...ticks, receivedAt: Date.now() } : null;
  listeners.forEach((l) => l());
};

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

/** The latest ticks (any symbol, or only `symbol`'s), or null when none or stale. */
export const useLiveTicks = (symbol) => {
  const t = useSyncExternalStore(subscribe, () => current);
  if (!t || Date.now() - t.receivedAt > MAX_AGE_MS) return null;
  if (symbol && t.symbol !== symbol) return null;
  return t;
};

/**
 * Live LTP for a strike from the ticks, or null. Key "20-Oct-2026|23100|CE" as TickFeedService.key
 * builds it; without an expiry, the first held expiry of that strike and side.
 */
export const tickLtp = (ticks, expiry, strike, right) => {
  if (!ticks?.ltps || strike == null || !right) return null;
  const tail = `${Number(strike)}|${right}`;
  if (expiry) {
    const v = ticks.ltps[`${expiry}|${tail}`];
    if (v != null) return v;
  }
  const hit = Object.keys(ticks.ltps).find((k) => k.endsWith(`|${tail}`));
  return hit ? ticks.ltps[hit] : null;
};
